import type { SVGProps } from 'react';

type SupportHeadsetProps = SVGProps<SVGSVGElement> & {
  title?: string;
};

/** White headset glyph for the floating Support FAB (Figma Frame 35). */
const SupportHeadset = ({ title, ...props }: SupportHeadsetProps) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : true}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M5 13.5V12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12V13.5"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
    />
    <rect
      x={3.1}
      y={11.25}
      width={3.8}
      height={6}
      rx={1.9}
      stroke="currentColor"
      strokeWidth={1.8}
    />
    <rect
      x={17.1}
      y={11.25}
      width={3.8}
      height={6}
      rx={1.9}
      stroke="currentColor"
      strokeWidth={1.8}
    />
    <path
      d="M6.9 15.75H9.2C9.2 15.75 10.05 17.85 12.15 17.85"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SupportHeadset;
